import React, {useContext} from "react";
import "./Header.css";
import SLogo from "../../../assets/images/SLogo.png";
import {useHistory} from "react-router-dom";
import AffinityInfoContext from "../../../context/AffinityContext";

const Header = () => {
    const history = useHistory();
    const {
        affinityId,
        affinityInterCode
    } = useContext(AffinityInfoContext);
    return (
        <React.Fragment>
            <div
                className="superior-rectangle"
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    height: "70px",
                }}
            >
                    <img
                        className="s-logo"
                        style={{marginLeft: "30px", width: "140px", height: "auto", cursor:"pointer"}}
                        src={SLogo}
                        alt="SLogo"
                        onClick={() => {
                            history.push({pathname: '/a/'+ affinityInterCode +'/' + affinityId + '/productos'})
                        }}
                    />
                </div>
        </React.Fragment>
    );
};

export default Header;
